import { ClickAwayListener, Popper } from '@material-ui/core';
import { isNil } from 'lodash';
import React from 'react';

import { useUnsetFocusedFieldProps } from '../../actions/shortcuts';
import { Shortcuts } from '../Shortcuts/Shortcuts';
import { Paper } from '../material-ui/Paper';
import { useShortcutPanel } from './hooks';
import { useStyles } from './useStyles';

const ShortcutsPanel = () => {
    const { shortcuts, value, changeHandler, anchorEl = null } = useShortcutPanel();
    const isShortcutsExist = !isNil(shortcuts) && Boolean(shortcuts.length);
    const isAnchorExist = !isNil(anchorEl);
    const [open, setOpen] = React.useState(isShortcutsExist && isAnchorExist);
    const classes = useStyles();
    const unsetFocusedFieldProps = useUnsetFocusedFieldProps();

    React.useEffect(() => {
        const isOpen = shortcuts && Boolean(shortcuts.length) && Boolean(anchorEl);
        setOpen(isOpen);
        if (isOpen && window.cordova && window.cordova.plugins) {
            window.cordova.plugins.Keyboard.close();
        }
    }, [shortcuts, anchorEl]);

    const handleClick = React.useCallback(
        (evt) => {
            evt.preventDefault();
            if (evt.currentTarget.tagName === 'BUTTON') {
                if (evt.currentTarget.value === 'manual') {
                    changeHandler(evt.currentTarget.value);
                    if (window.cordova && window.cordova.plugins) {
                        window.cordova.plugins.Keyboard.show();
                    }

                    return;
                }
                changeHandler(evt.currentTarget.value);
                unsetFocusedFieldProps();
            }
        },
        [changeHandler]
    );

    const handleClickAway = React.useCallback(() => {
        unsetFocusedFieldProps();
    }, []);

    if (!isAnchorExist) {
        return null;
    }

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            className={classes.popper}
            modifiers={{
                preventOverflow: {
                    enabled: true,
                    boundariesElement: 'viewport',
                    arrow: true,
                },
            }}
            disablePortal={true}
        >
            <ClickAwayListener mouseEvent="onMouseDown" onClickAway={handleClickAway}>
                <Paper elevation={2} className={classes.container}>
                    <Shortcuts shortcuts={shortcuts} clickHandler={handleClick} currentValue={value} />
                </Paper>
            </ClickAwayListener>
        </Popper>
    );
};

export { ShortcutsPanel };
